import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../ui/button';
import { useArchonAccess } from '../context/ArchonAccessContext';
import { EmptyState } from './EmptyState';
import { PanelSkeleton } from './PanelSkeleton';

/** Renders an owner-only Archon page for its owners, and a plain refusal for anyone else. */
export const ArchonOwnerOnly: React.FC<PropsWithChildren> = ({ children }) => {
  const { canManageData, error, retry } = useArchonAccess();
  if (canManageData) return <>{children}</>;
  if (error) {
    return (
      <div className="archon-page">
        <EmptyState
          title="Access check failed"
          description={error}
          action={<Button onClick={retry}>Try again</Button>}
        />
      </div>
    );
  }
  if (canManageData === null) return <PanelSkeleton shape="table" />;
  return (
    <div className="archon-page">
      <EmptyState
        title="Owners only"
        description="This page sets fleet-wide inputs, so only its owners can open it."
      />
    </div>
  );
};

/** A link to an owner-only page for its owners; plain text for anyone the page would refuse. */
export function ArchonOwnerLink({ to, children }: PropsWithChildren<{ to: string }>) {
  const { canManageData } = useArchonAccess();
  if (!canManageData) return <>{children}</>;
  return (
    <Link to={to} className="underline underline-offset-4">
      {children}
    </Link>
  );
}
